export default {
  namespaced: true,
  proxy_rtsp_server: {
    title: "proxy rtsp server | servidores proxy rtsp",
    name: "nome",
    api_host: "host da API",
    rtsp_host: "host RTSP",
    playback_host: "host de reprodução",
    hls_host: "host HLS",
    webrtc_host: "host WebRTC",
    log_level: "Nível de Log",
    log_destinations: "Destinos de Log",
    log_file: "Arquivo de Log",
    sys_log_prefix: "Prefixo de Syslog",
    read_timeout: "Tempo limite de leitura",
    write_timeout: "Tempo limite de escrita",
    write_queue_size: "Tamanho da fila de escrita",
    udp_max_payload_size: "Tamanho máximo de payload UDP",
    run_on_connect: "Executar ao Conectar",
    run_on_connect_restart: "Reiniciar ao Conectar",
    run_on_disconnect: "Executar ao Desconectar",
    auth_method: "Método de Autenticação",
    auth_internal_users: "Usuários Internos",
    auth_http: "Autenticação HTTP",
    auth_http_address: "Endereço de Autenticação HTTP",
    auth_http_exclude: "Excluir Autenticação HTTP",
    auth_jwt_jwks: "JWT JWKS",
    auth_jwt_jwks_fingerprint: "Impressão Digital do JWT JWKS",
    auth_jwt_claim_key: "Chave de Reivindicação JWT",
    auth_jwt_exclude: "Excluir JWT",
    auth_jwt_in_http_query: "JWT na Consulta HTTP",
    enable_api: "Ativar API",
    api_address: "Endereço da API",
    enable_api_encryption: "Ativar Criptografia da API",
    api_server_key: "Chave do Servidor da API",
    api_server_cert: "Certificado do Servidor da API",
    api_allow_origin: "Origem Permitida da API",
    api_trusted_proxies: "Proxies Confiáveis da API",
    enable_metrics: "Ativar Métricas",
    metrics_address: "Endereço de Métricas",
    enable_metrics_encryption: "Ativar Criptografia de Métricas",
    metrics_server_key: "Chave do Servidor de Métricas",
    metrics_server_cert: "Certificado do Servidor de Métricas",
    metrics_allow_origin: "Origem Permitida de Métricas",
    metrics_trusted_proxies: "Proxies Confiáveis de Métricas",
    enable_pprof: "Ativar Pprof",
    pprof_address: "Endereço Pprof",
    enable_pprof_encryption: "Ativar Criptografia Pprof",
    pprof_server_key: "Chave do Servidor Pprof",
    pprof_server_cert: "Certificado do Servidor Pprof",
    pprof_allow_origin: "Origem Permitida Pprof",
    pprof_trusted_proxies: "Proxies Confiáveis Pprof",
    enable_playback: "Ativar Reprodução",
    playback_address: "Endereço de Reprodução",
    enable_playback_encryption: "Ativar Criptografia da Reprodução",
    playback_server_key: "Chave do Servidor de Reprodução",
    playback_server_cert: "Certificado do Servidor de Reprodução",
    playback_allow_origin: "Origem Permitida da Reprodução",
    playback_trusted_proxies: "Proxies Confiáveis da Reprodução",
    enable_rtsp: "Ativar RTSP",
    rtsp_transports: "Transportes RTSP",
    rtsp_encryption: "Criptografia RTSP",
    rtsp_address: "Endereço RTSP",
    rtsps_address: "Endereço RTSPS",
    rtp_address: "Endereço RTP",
    rtcp_address: "Endereço RTCP",
    multicast_ip_range: "Faixa de IP Multicast",
    multicast_rtp_port: "Porta RTP Multicast",
    multicast_rtcp_port: "Porta RTCP Multicast",
    rtsp_server_key: "Chave do Servidor RTSP",
    rtsp_server_cert: "Certificado do Servidor RTSP",
    rtsp_auth_methods: "Métodos de Autenticação RTSP",
    enable_rtmp: "Ativar RTMP",
    rtmp_address: "Endereço RTMP",
    rtmp_encryption: "Criptografia RTMP",
    rtmps_address: "Endereço RTMPS",
    rtmp_server_key: "Chave do Servidor RTMP",
    rtmp_server_cert: "Certificado do Servidor RTMP",
    enable_hls: "Ativar HLS",
    hls_address: "Endereço HLS",
    enable_hls_encryption: "Ativar Criptografia HLS",
    hls_server_key: "Chave do Servidor HLS",
    hls_server_cert: "Certificado do Servidor HLS",
    hls_allow_origin: "Origem Permitida HLS",
    hls_trusted_proxies: "Proxies Confiáveis HLS",
    hls_always_remux: "Sempre Remuxar HLS",
    hls_variant: "Variante HLS",
    hls_segment_count: "Quantidade de Segmentos HLS",
    hls_segment_duration: "Duração dos Segmentos HLS",
    hls_part_duration: "Duração das Partes HLS",
    hls_segment_max_size: "Tamanho Máximo do Segmento HLS",
    hls_directory: "Diretório HLS",
    hls_muxer_close_after: "Fechar Muxer HLS Após",
    enable_webrtc: "Ativar WebRTC",
    webrtc_address: "Endereço WebRTC",
    enable_webrtc_encryption: "Ativar Criptografia WebRTC",
    webrtc_server_key: "Chave do Servidor WebRTC",
    webrtc_server_cert: "Certificado do Servidor WebRTC",
    webrtc_allow_origin: "Origem Permitida WebRTC",
    webrtc_trusted_proxies: "Proxies Confiáveis WebRTC",
    webrtc_local_udp_address: "Endereço UDP Local WebRTC",
    webrtc_local_tcp_address: "Endereço TCP Local WebRTC",
    webrtc_ips_from_interfaces: "IPs das Interfaces WebRTC",
    webrtc_ips_from_interfaces_list: "Lista de Interfaces WebRTC",
    webrtc_additional_hosts: "Hosts Adicionais WebRTC",
    webrtc_ice_servers_2: "Servidores ICE WebRTC 2",
    webrtc_handshake_timeout: "Tempo de Handshake WebRTC",
    webrtc_track_gather_timeout: "Tempo de Coleta de Faixas WebRTC",
    webrtc_stun_gather_timeout: "Tempo de Coleta STUN WebRTC",
    enable_srt: "Ativar SRT",
    srt_address: "Endereço SRT",
    api_settings: "Configurações da API",
    authentication: "Autenticação",
    password_not_required_for_user_any: "Senha não exigida para o usuário 'any'"
  },
};
